<template>
  <div class="container page-content">
    
    <div class="row page-content__heading">
      <div class="col-12">
        <h1>{{ $t('contact.heading') }}</h1>
        <div v-html="$t('contact.content')"></div>
      </div>
    </div>

  </div>
</template>

<script>
  import scrollToElement from 'scroll-to-element'

  export default {
    name: "contact",
    data () {
      return {
        
      }
    },
    mounted () {
      scrollToElement('.page-content', {
        offset: 0,
        ease: 'out-cube',
        duration: 800
      })
    }
  }
</script>

<style lang="scss" scoped>
  .page-content {
    padding-top: 50px;
    padding-bottom: 50px;

    .page-content__heading {
      margin-bottom: 40px;
      
      h1 {
        font-size: 34px;
        font-weight: 300;
        margin-bottom: 30px;
      }

      .heading__info {
        font-size: 12px;
        margin-top: 10px;
        font-weight: 400;
      }
    }

    .page-content__products {
      margin-top: 80px;

      .products__heading {
        background: #f0f0f0;
        padding-top: 10px;
        padding-bottom: 10px;
        font-weight: 900;
        font-size: 14px;
        text-transform: uppercase; 
        
        img {
          margin-right: 10px;
        }
      }

      .products__list {
        ul {
          list-style: none;
          padding-left: 20px;
          margin-bottom: 0px;
          margin-top: 20px;
          columns: 3;
          -webkit-columns: 3;
          -moz-columns: 3;

          li {
            margin-bottom: 10px;
          }
        }
      }

    }
  }
</style>
